import type { ButtonProps } from "@mui/material/Button";

import { useCallback } from "react";
import { signOut } from "@/src/auth/context/firebase";

import Button from "@mui/material/Button";

import { useRouter } from "src/routes/hooks";
import { paths } from 'src/routes/paths';

import { useAuthContext } from "src/auth/hooks";

// ----------------------------------------------------------------------

type Props = ButtonProps & {
  onClose?: () => void;
};

export function LoggaUtKnapp({ onClose, sx, ...other }: Props) {
  const router = useRouter();

  const { checkUserSession } = useAuthContext();

  const handleLogout = useCallback(async () => {
    try {
      await signOut();
      await checkUserSession?.();

      onClose?.();
      router.replace(paths.LOGGA_IN);
    } catch (error) {
      console.error(error);
    }
  }, [checkUserSession, onClose, router]);

  return (
    <Button
      fullWidth
      variant="soft"
      size="large"
      color="error"
      onClick={handleLogout}
      sx={sx}
      {...other}
    >
      Logga ut
    </Button>
  );
}
